<h2 mat-dialog-title class="dialog-title">
  <span class="badge"><mat-icon>schedule</mat-icon></span>
  <span class="text" translate="CALLS.EXTEND_RETENTION.TITLE"></span>
  <button mat-icon-button [mat-dialog-close]="null" [attr.aria-label]="'COMMON.CLOSE' | translate"><mat-icon>close</mat-icon></button>
</h2>
<mat-dialog-content>
  <p class="description">
    {{ 'CALLS.EXTEND_RETENTION.DESCRIPTION' | translate: { callName: data.callName, recoveryWindow: recoveryWindowLabel } }}
  </p>

  <app-retention-timeline [view]="timeline" (extensionInDaysChange)="applyExtensionInDays($event)"></app-retention-timeline>

  <div class="quick-extend">
    <span class="section-label" translate="CALLS.EXTEND_RETENTION.QUICK_EXTEND"></span>
    <div class="options">
      @for (days of quickExtensionsInDays; track days) {
        <!-- disabledInteractive, so a blocked option still takes the pointer and can show the tooltip
             that says why it is out of reach. The click is refused in the handler. -->
        <button
          mat-stroked-button
          type="button"
          class="option"
          [class.selected]="isQuickExtensionSelected(days)"
          [disabled]="isQuickExtensionBlocked(days)"
          [disabledInteractive]="true"
          [matTooltip]="quickExtensionTooltip(days)"
          (click)="applyQuickExtension(days)"
        >
          {{ quickExtensionLabel(days) }}
        </button>
      }
      @if (hasMaximum) {
        <button
          mat-stroked-button
          type="button"
          class="option maximum"
          [class.selected]="isMaximumSelected"
          (click)="applyMaximum()"
          translate="CALLS.EXTEND_RETENTION.MAX_ALLOWED"
        ></button>
      }
    </div>
  </div>

  <div class="date-fields">
    <div class="field">
      <app-datetime-picker
        [(ngModel)]="softDeletionDate"
        name="soft-deletion-date"
        translationKey="CALLS.EXTEND_RETENTION.SOFT_DELETION_DATE"
        [isDateInvalid]="isDateInvalid"
        [errorMessageKey]="errorMessageKey"
        [max]="maximumSoftDeletionDate"
      ></app-datetime-picker>
      <p class="hint">
        @if (maximumSoftDeletionDate !== null) {
          {{ 'CALLS.EXTEND_RETENTION.SOFT_DELETION_HINT_CAPPED' | translate: { date: maximumSoftDeletionDate | date: dateTimeFormat } }}
        } @else {
          {{ 'CALLS.EXTEND_RETENTION.SOFT_DELETION_HINT' | translate }}
        }
      </p>
    </div>
    <div class="field">
      <!-- Read-only rather than a disabled picker: this date is derived, and a disabled ngModel field
           stops following the value it is derived from. -->
      <mat-form-field subscriptSizing="dynamic">
        <mat-label translate="CALLS.EXTEND_RETENTION.CURRENT_DELETION_DATE"></mat-label>
        <input matInput readonly [value]="deletionDate | date: dateTimeFormat" />
      </mat-form-field>
      <p class="hint">{{ 'CALLS.EXTEND_RETENTION.HARD_DELETION_HINT' | translate: { recoveryWindow: recoveryWindowLabel } }}</p>
    </div>
  </div>

  <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="dialogResult" [disabled]="!canSave" translate="COMMON.SAVE" color="primary"></button>
</mat-dialog-actions>
